export default __webpack_public_path__ + "media/images/noukaweb-subsidy-logo.7c023b1e2b380bd3c7d035c6559c4d2b.webp";